import React from 'react'
import styled from 'styled-components'

import { SelectableIconButton } from '../../molecules/SelectableButton'

import slaughterIconUrl from '../../../assets/abate.svg'
import agricultureIconUrl from '../../../assets/agricultura.svg'
import extractivismIconUrl from '../../../assets/extrativismo.svg'
import cattleIconUrl from '../../../assets/rebanho.svg'
import censoIconUrl from '../../../assets/censo.png'
import fundiarioIconUrl from '../../../assets/fundiario.svg'

const ButtonRow = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
`

const Button = styled(SelectableIconButton)`
  margin-right: 16px;
  margin-bottom: 16px;

  &:last-child {
    margin-right: 0
  }
`

class ResearchThemeButtonGroup extends React.PureComponent {
  get selectedThemeName() {
    if (this.props.selectedTheme) {
      return this.props.selectedTheme.name
    }

    return null
  }

  setSelectedField = (field) => {
    if (this.selectedThemeName === field) {
      this.props.onChange(null)
    } else {
      this.props.onChange(field)
    }
  }

  handleButtonClickMemoizedFunctions = {}
  handleButtonClick = (field) => {
    if (this.handleButtonClickMemoizedFunctions[field]) {
      return this.handleButtonClickMemoizedFunctions[field]
    }

    return this.handleButtonClickMemoizedFunctions[field] = () => {
      this.setSelectedField(field)
    }
  }

  render() {
    return (
      <ButtonRow>
        <Button
          iconUrl={ agricultureIconUrl }
          onClick={ this.handleButtonClick('AGRICULTURA') }
          selected={ this.selectedThemeName === 'AGRICULTURA' }
        >
          survey.themes.AGRICULTURA
        </Button>
        <Button
          iconUrl={ cattleIconUrl }
          onClick={ this.handleButtonClick('PECUARIA_PROD_REBANHO') }
          selected={ this.selectedThemeName === 'PECUARIA_PROD_REBANHO' }
        >
          survey.themes.PECUARIA_PROD_REBANHO
        </Button>
        <Button
          iconUrl={ extractivismIconUrl }
          onClick={ this.handleButtonClick('FLORESTAL') }
          selected={ this.selectedThemeName === 'FLORESTAL' }
        >
          survey.themes.FLORESTAL
        </Button>
        <Button
          iconUrl={ slaughterIconUrl }
          onClick={ this.handleButtonClick('PECUARIA_ABATE') }
          selected={ this.selectedThemeName === 'PECUARIA_ABATE' }
        >
          survey.themes.PECUARIA_ABATE
        </Button>
        <Button
          iconUrl={ censoIconUrl }
          onClick={ this.handleButtonClick('CENSO AGROPECUARIO') }
          selected={ this.selectedThemeName === 'CENSO AGROPECUARIO' }
        >
          survey.themes.CENSO_AGROPECUARIO
        </Button>
        <Button
          iconUrl={ fundiarioIconUrl }
          onClick={ this.handleButtonClick('FUNDIARIO') }
          selected={ this.selectedThemeName === 'FUNDIARIO' }
        >
          survey.themes.FUNDIARIO
        </Button>
      </ButtonRow>
    )
  }
}

export default ResearchThemeButtonGroup



// WEBPACK FOOTER //
// ./src/components/molecules/ResearchThemeButtonGroup/ResearchThemeButtonGroup.js